import API from '@/api/path'
import { baseFetch } from '@/api/axiosBase'
import { getNvrModelIdList, getCamModelIdList } from '@/utils/parameters/deviceModel'

const videoModule = {
  state: {
    nvrList: [],
    cameraList: [],
  },
  actions: {
    // 取得nvr設備列表
    async getNvrDeviceList({ commit, rootState }, searchParams) {
      const currentCommunityId = rootState.commonModule.currentCommunityId
      try {
        const res = await baseFetch(
          API.getNvrDeviceList.url,
          API.getNvrDeviceList.method, 
          {
            ...searchParams,
            // models: 'AltesecNvr',
            commulityId: currentCommunityId
          }
        )
        if (!res.isError && res.data) {
          // console.log('nvrData:'+JSON.stringify(res.data))
          let nvrIdArr = getNvrModelIdList()
          let filterData = res.data.data.filter(function(item){
            return nvrIdArr.includes(item.modelId)
          })
          commit('SET_NVR_LIST', filterData)
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    // 取得CAM設備列表
    async getCameraDeviceList({ commit, rootState }, searchParams) {
      const currentCommunityId = rootState.commonModule.currentCommunityId
      try {
        const res = await baseFetch(
          API.getNvrDeviceList.url,
          API.getNvrDeviceList.method, 
          { 
            ...searchParams,
            // models: 'AltesecNvrCam',
            commulityId: currentCommunityId
          }
        )
        if (!res.isError && res.data) {
          // console.log('camData:'+JSON.stringify(res.data))
          let cameraIdArr = getCamModelIdList()
          let filterData = res.data.data.filter(function(item){
            return cameraIdArr.includes(item.modelId)
          })
          commit('SET_CAMERA_LIST', filterData)
        }
      } catch (error) {
        console.error('error', error)
      }
    },
  },
  mutations: {
    SET_NVR_LIST(state, payload) {
      // // TODO 測試demo用待刪除
      // let hunt_nvr_fake_data = 
      // {
      //   'id': 'b3aee271-7a07-4508-9488-f38125540302',
      //   'parent': null,
      //   'devId': 'HUSTNVFU232410a8',
      //   'name': 'NVR_hunt',
      //   'modelId': 17,
      //   'modelName': 'HNR-04KD',
      //   'owner': null,
      //   'activeappid': 0,
      //   'status': 0,
      //   'profiles': [],
      //   'attrs': {
      //       'aIProduct': '',
      //       'acc': 'msoadmin',
      //       'activeTime': '2023-10-16 23:51:32',
      //       'area': '',
      //       'buildingNo': '',
      //       'cust_id': 'Kbro3000',
      //       'floor': '',
      //       'ip': '192.168.11.66',
      //       'port': '10240',
      //       'pwd': 'msoadmin',
      //       'rtspPort': '10340',
      //       'so': '220',
      //       'stopService': '',
      //       'subsid': '9999',
      //       'workodr': 'workodr01'
      //   },
      //   'vals': {}
      // }
      // payload.push(hunt_nvr_fake_data)

      state.nvrList = payload
    },
    SET_CAMERA_LIST(state, payload) {

      // // TODO 測試demo用待刪除
      // let hunt_cam_fake_data = 
      // {
      //   'id': 'b3aee271-7a07-4508-9488-f38125540303',
      //   'parent': 'b3aee271-7a07-4508-9488-f38125540302',
      //   'devId': 'camHunt00001',
      //   'name': '杭特camera',
      //   'modelId': 8,
      //   'modelName': 'HLC-6GMQ',
      //   'owner': null,
      //   'activeappid': 0,
      //   'status': 0,
      //   'profiles': [],
      //   'attrs': {
      //       'acc': 'msoadmin',
      //       'activeTime': '2023-10-16 23:51:32',
      //       'aiProduct': '[\'human\',\'climb\',\'stay\',\'gather\',\'crowd\',\'fall\',\'home\']',
      //       'aliableAiProduct': '[\'human\',\'gather\',\'crowd\',\'fall\',\'home\']',
      //       'area': '',
      //       'buildingNo': '10',
      //       'ch': '0',
      //       'floor': '14',
      //       'ip': '192.168.11.66',
      //       'nvrId': 'HUSTNVFU232410a8',
      //       'port': '10240',
      //       'pwd': 'msoadmin',
      //       'rtspPort': '10340',
      //       'so': 'mso1',
      //       'workodr': 'workodr01'
      //   },
      //   'vals': {}
      // }
      // payload.push(hunt_cam_fake_data)
      state.cameraList = payload
    },
  },
  getters: {
    getNVRList: (state) => state.nvrList,
    getCameraList: (state) => state.cameraList,
  },
  namespaced: true
}

export default videoModule